<div class="d-flex year-month-filter-container mt-2"
     [formGroup]="formGroup()">
    <kendo-label text="Year(s):" class="years-control muted-small">
        <kendo-multiselect [data]="years"
                           [formControlName]="yearsFormControlName()"
                           (valueChange)="onYearSelectionChange()"></kendo-multiselect>
    </kendo-label>
    <kendo-label text="Month(s):" class="months-control muted-small">
        <kendo-multiselect [data]="months"
                           [formControlName]="monthsFormControlName()"
                           textField="name"
                           (valueChange)="onMonthSelectionChange()"
                           valueField="number"
                           [valuePrimitive]="true">
        </kendo-multiselect>
    </kendo-label>
</div>
